// frontend/src/manager_notifications/notificationTypes.js

export const NOTIFICATION_TYPES = {
  // Événements planning
  FLIGHT: { id: 'flight', label: 'Flight', icon: 'Plane', category: 'schedule', defaultPriority: 'high' },
  FUEL: { id: 'fuel', label: 'Fuel', icon: 'Fuel', category: 'schedule', defaultPriority: 'normal' },
  MAINTENANCE: { id: 'maintenance', label: 'Maintenance', icon: 'Wrench', category: 'schedule', defaultPriority: 'high' },
  MEETING: { id: 'meeting', label: 'Meeting', icon: 'Users', category: 'schedule', defaultPriority: 'normal' },
  APPOINTMENT: { id: 'appointment', label: 'Appointment', icon: 'Calendar', category: 'schedule', defaultPriority: 'normal' },
  
  // Alertes
  EMERGENCY_ALERT: { id: 'emergency', label: 'Emergency', icon: 'AlertTriangle', category: 'alert', defaultPriority: 'critical' },
  WARNING_ALERT: { id: 'warning', label: 'Warning', icon: 'AlertTriangle', category: 'alert', defaultPriority: 'high' },
  INFO_ALERT: { id: 'info', label: 'Info', icon: 'Bell', category: 'alert', defaultPriority: 'low' },
  SUCCESS_ALERT: { id: 'success', label: 'Success', icon: 'CheckCircle', category: 'alert', defaultPriority: 'normal' },
  
  // Messages chat
  CHAT_MESSAGE: { id: 'chat', label: 'Chat Message', icon: 'MessageSquare', category: 'chat', defaultPriority: 'normal' },
  APPOINTMENT_REQUEST: { id: 'appointment_request', label: 'Appointment Request', icon: 'Calendar', category: 'chat', defaultPriority: 'high' },
  APPOINTMENT_RESPONSE: { id: 'appointment_response', label: 'Appointment Response', icon: 'CheckCircle', category: 'chat', defaultPriority: 'normal' },
  
  // Demandes clients (fuel, maintenance)
  FUEL_REQUEST: { id: 'fuel_request', label: 'Fuel Request', icon: 'Fuel', category: 'request', defaultPriority: 'high' },
  MAINTENANCE_REQUEST: { id: 'maintenance_request', label: 'Maintenance Request', icon: 'Wrench', category: 'request', defaultPriority: 'high' },
  
  // ═══════════════════════════════════════════════════════════════════════════
  // NOUVEAU: Inspections (FAA compliant)
  // ═══════════════════════════════════════════════════════════════════════════
  INSPECTION_DUE: { id: 'inspection_due', label: 'Inspection Due', icon: 'ClipboardList', category: 'inspection', defaultPriority: 'high' },
  INSPECTION_COMPLETED: { id: 'inspection_completed', label: 'Inspection Completed', icon: 'CheckCircle', category: 'inspection', defaultPriority: 'normal' },
  INSPECTION_FAILED: { id: 'inspection_failed', label: 'Inspection Failed', icon: 'AlertTriangle', category: 'inspection', defaultPriority: 'critical' },
  INSPECTION_OVERDUE: { id: 'inspection_overdue', label: 'Inspection Overdue', icon: 'AlertCircle', category: 'inspection', defaultPriority: 'critical' },
  INSPECTION_NEEDS_REVIEW: { id: 'inspection_needs_review', label: 'Inspection Needs Review', icon: 'Eye', category: 'inspection', defaultPriority: 'high' },
  
  // ═══════════════════════════════════════════════════════════════════════════
  // NOUVEAU: Tasks (Recurring tasks & assignments)
  // ═══════════════════════════════════════════════════════════════════════════
  TASK_DUE: { id: 'task_due', label: 'Task Due', icon: 'CheckSquare', category: 'task', defaultPriority: 'normal' },
  TASK_COMPLETED: { id: 'task_completed', label: 'Task Completed', icon: 'CheckCircle', category: 'task', defaultPriority: 'low' },
  TASK_OVERDUE: { id: 'task_overdue', label: 'Task Overdue', icon: 'AlertCircle', category: 'task', defaultPriority: 'high' },
  TASK_ASSIGNED: { id: 'task_assigned', label: 'Task Assigned', icon: 'UserPlus', category: 'task', defaultPriority: 'normal' },
  
  // ═══════════════════════════════════════════════════════════════════════════
  // NOUVEAU: Escalation (for overdue tasks)
  // ═══════════════════════════════════════════════════════════════════════════
  ESCALATION_SUPERVISOR: { id: 'escalation_supervisor', label: 'Escalation - Supervisor', icon: 'AlertTriangle', category: 'alert', defaultPriority: 'high' },
  ESCALATION_MANAGER: { id: 'escalation_manager', label: 'Escalation - Manager', icon: 'AlertTriangle', category: 'alert', defaultPriority: 'critical' },
  
  // ═══════════════════════════════════════════════════════════════════════════
  // NOUVEAU: Certifications (Staff certifications expiring)
  // ═══════════════════════════════════════════════════════════════════════════
  CERT_EXPIRING_SOON: { id: 'cert_expiring_soon', label: 'Certification Expiring Soon', icon: 'Award', category: 'hr', defaultPriority: 'high' },
  CERT_EXPIRED: { id: 'cert_expired', label: 'Certification Expired', icon: 'AlertCircle', category: 'hr', defaultPriority: 'critical' },
  CERT_ADDED: { id: 'cert_added', label: 'Certification Added', icon: 'Plus', category: 'hr', defaultPriority: 'low' },
  
  // ═══════════════════════════════════════════════════════════════════════════
  // NOUVEAU: Deletion Audit
  // ═══════════════════════════════════════════════════════════════════════════
  RECORD_DELETED: { id: 'record_deleted', label: 'Record Deleted', icon: 'Trash2', category: 'audit', defaultPriority: 'low' },
  RECORD_RESTORED: { id: 'record_restored', label: 'Record Restored', icon: 'RotateCcw', category: 'audit', defaultPriority: 'low' },
  
  // Système
  SYSTEM_NOTIFICATION: { id: 'system', label: 'System', icon: 'Settings', category: 'system', defaultPriority: 'low' }
};

// ═══════════════════════════════════════════════════════════════════════════
// Catégories de notifications
// ═══════════════════════════════════════════════════════════════════════════

export const NOTIFICATION_CATEGORIES = {
  schedule: { label: 'Schedule', color: 'blue', order: 1, icon: 'Calendar' },
  alert: { label: 'Alerts', color: 'red', order: 0, icon: 'AlertTriangle' },
  chat: { label: 'Chat', color: 'green', order: 2, icon: 'MessageSquare' },
  request: { label: 'Client Requests', color: 'orange', order: 0, icon: 'ClipboardList' },
  inspection: { label: 'Inspections', color: 'cyan', order: 1, icon: 'ClipboardList' },
  task: { label: 'Tasks', color: 'purple', order: 1, icon: 'CheckSquare' },
  hr: { label: 'HR & Certifications', color: 'yellow', order: 2, icon: 'Award' },
  audit: { label: 'Audit', color: 'gray', order: 3, icon: 'History' },
  system: { label: 'System', color: 'gray', order: 3, icon: 'Settings' }
};

// ═══════════════════════════════════════════════════════════════════════════
// Niveaux de priorité
// ═══════════════════════════════════════════════════════════════════════════

export const PRIORITY_LEVELS = {
  critical: { label: 'CRITICAL', color: 'red', weight: 0, icon: 'AlertTriangle' },
  high: { label: 'HIGH', color: 'orange', weight: 1, icon: 'AlertCircle' },
  normal: { label: 'NORMAL', color: 'blue', weight: 2, icon: 'Bell' },
  low: { label: 'LOW', color: 'gray', weight: 3, icon: 'Info' }
};

// ═══════════════════════════════════════════════════════════════════════════
// Statuts pour les demandes clients
// ═══════════════════════════════════════════════════════════════════════════

export const REQUEST_STATUS = {
  pending: { label: 'Pending', color: 'yellow', icon: 'Clock' },
  approved: { label: 'Approved', color: 'green', icon: 'CheckCircle' },
  rejected: { label: 'Rejected', color: 'red', icon: 'XCircle' },
  completed: { label: 'Completed', color: 'blue', icon: 'CheckCircle' },
  cancelled: { label: 'Cancelled', color: 'gray', icon: 'XCircle' }
};

// ═══════════════════════════════════════════════════════════════════════════
// Actions possibles sur les demandes
// ═══════════════════════════════════════════════════════════════════════════

export const REQUEST_ACTIONS = {
  approve: { label: 'Approve', color: 'green', icon: 'CheckCircle' },
  reject: { label: 'Reject', color: 'red', icon: 'XCircle' },
  complete: { label: 'Complete', color: 'blue', icon: 'CheckCircle' }
};

// ═══════════════════════════════════════════════════════════════════════════
// Statuts pour les événements (schedule)
// ═══════════════════════════════════════════════════════════════════════════

export const STATUS_CONFIG = {
  check_in: { label: 'Check-in', icon: 'CheckCircle', color: 'green' },
  check_out: { label: 'Check-out', icon: 'XCircle', color: 'red' },
  billing: { label: 'Billing', icon: 'DollarSign', color: 'yellow' },
  grading: { label: 'Grading', icon: 'FileText', color: 'blue' },
  squawk: { label: 'Squawk', icon: 'AlertCircle', color: 'orange' }
};

// ═══════════════════════════════════════════════════════════════════════════
// Statuts pour les inspections
// ═══════════════════════════════════════════════════════════════════════════

export const INSPECTION_STATUS = {
  scheduled: { label: 'Scheduled', color: 'blue', icon: 'Calendar' },
  in_progress: { label: 'In Progress', color: 'yellow', icon: 'Clock' },
  completed: { label: 'Completed', color: 'green', icon: 'CheckCircle' },
  overdue: { label: 'Overdue', color: 'red', icon: 'AlertCircle' },
  cancelled: { label: 'Cancelled', color: 'gray', icon: 'XCircle' },
  needs_review: { label: 'Needs Review', color: 'orange', icon: 'Eye' }
};

export const INSPECTION_RESULT = {
  pass: { label: 'PASS', color: 'green', icon: 'CheckCircle' },
  fail: { label: 'FAIL', color: 'red', icon: 'XCircle' },
  warning: { label: 'WARNING', color: 'yellow', icon: 'AlertTriangle' },
  needs_inspection: { label: 'Needs Inspection', color: 'orange', icon: 'Clock' }
};

// ═══════════════════════════════════════════════════════════════════════════
// Règles de filtrage par défaut
// ═══════════════════════════════════════════════════════════════════════════

export const DEFAULT_FILTERS = {
  maxAge: 7, // days
  includeCompleted: false,
  minPriority: 'low',
  categories: ['schedule', 'alert', 'chat', 'request', 'inspection', 'task', 'hr', 'audit', 'system']
};

// ═══════════════════════════════════════════════════════════════════════════
// Configuration des couleurs par type d'événement (schedule)
// ═══════════════════════════════════════════════════════════════════════════

export const EVENT_COLORS = {
  flight: 'blue',
  fuel: 'orange',
  maintenance: 'red',
  meeting: 'purple',
  appointment: 'green',
  inspection: 'cyan',
  task: 'purple'
};

// ═══════════════════════════════════════════════════════════════════════════
// Types de zones aéroportuaires (pour filtrage)
// ═══════════════════════════════════════════════════════════════════════════

export const ZONE_TYPES = {
  runway: { label: 'Runway', icon: 'Plane', color: 'blue' },
  taxiway: { label: 'Taxiway', icon: 'Navigation', color: 'cyan' },
  apron: { label: 'Apron', icon: 'MapPin', color: 'purple' },
  fuel_farm: { label: 'Fuel Farm', icon: 'Fuel', color: 'orange' },
  terminal: { label: 'Terminal', icon: 'Building2', color: 'green' },
  maintenance: { label: 'Maintenance', icon: 'Wrench', color: 'yellow' },
  security_zone: { label: 'Security Zone', icon: 'Shield', color: 'red' },
  sida: { label: 'SIDA', icon: 'Shield', color: 'red' },
  hangar_area: { label: 'Hangar Area', icon: 'Warehouse', color: 'indigo' },
  ramp: { label: 'Ramp', icon: 'MapPin', color: 'slate' }
};

// ═══════════════════════════════════════════════════════════════════════════
// Fréquences des tâches récurrentes
// ═══════════════════════════════════════════════════════════════════════════

export const TASK_FREQUENCIES = {
  once: { label: 'Once', icon: 'Circle', color: 'gray' },
  daily: { label: 'Daily', icon: 'Sun', color: 'blue' },
  weekly: { label: 'Weekly', icon: 'Calendar', color: 'purple' },
  monthly: { label: 'Monthly', icon: 'Calendar', color: 'green' },
  quarterly: { label: 'Quarterly', icon: 'Calendar', color: 'orange' },
  semester: { label: 'Semester (6mo)', icon: 'Calendar', color: 'red' },
  yearly: { label: 'Yearly', icon: 'Calendar', color: 'yellow' }
};

// ═══════════════════════════════════════════════════════════════════════════
// Types de certifications staff
// ═══════════════════════════════════════════════════════════════════════════

export const CERTIFICATION_TYPES = {
  pilot: { label: 'Pilot', icon: 'Plane', color: 'blue' },
  a_and_p: { label: 'A&P Mechanic', icon: 'Wrench', color: 'cyan' },
  inspection_authorization: { label: 'Inspection Authorization', icon: 'ClipboardList', color: 'purple' },
  fuel_handler: { label: 'Fuel Handler', icon: 'Fuel', color: 'orange' },
  safety: { label: 'Safety', icon: 'AlertTriangle', color: 'yellow' },
  first_aid_cpr: { label: 'First Aid / CPR', icon: 'Heart', color: 'red' },
  faa_driver: { label: 'FAA Driver', icon: 'User', color: 'green' },
  sida_badge: { label: 'SIDA Badge', icon: 'Badge', color: 'indigo' },
  runway_safety: { label: 'Runway Safety', icon: 'AlertTriangle', color: 'amber' },
  fod_control: { label: 'FOD Control', icon: 'AlertTriangle', color: 'emerald' },
  aviation_security: { label: 'Aviation Security', icon: 'Shield', color: 'slate' },
  custom: { label: 'Custom', icon: 'Certificate', color: 'gray' }
};